import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment boostedSavings on UserSaving {
    boostedSavings {
      oldSavings {
        header
        type
        value
      }
    }
  }
`

export default fragment
